import React from 'react';
import "./c85_slider_alumni_students.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import { insertHtml } from "../../utils/dom";
import useWindowDimensions from "./useWindowDimensions";

const SliderAlumniStudents = (props) => {
    const { height, width } = useWindowDimensions(); // eslint-disable-line

    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        centerMode: true,
        centerPadding: width <= 1200 ? "190px" : "90px",
        speed: 500,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const cardNumber = (props.data.slider_cards).length;

    return <div id="sliderAlumniStudents" className="container-fluid">
        <div className="title">{props.data.title}</div>
        {props.data.description && <div className="description">{props.data.description}</div>}
        <Slider {...settings} className={cardNumber > 1 ? "scrolling-wrapper" : "scrolling-wrapper single-card"}>
            {props.data.slider_cards && props.data.slider_cards.map((object, index) => (
                <div key={index} className="card-container">
                    <div key={index} className="card">
                        <div className="left-content">
                            {object.label_student && <div className="img-banner">{object.label_student.toUpperCase()}</div>}
                            <img src={object.image} alt={object.name} />
                        </div>
                        <div className="right-content">
                            {object.url ? <a href={object.url}><div className="name">{object.name}</div></a> : <div className="name">{object.name}</div>}
                            <div className="motto-scrollable" {...insertHtml(object.motto)} />
                            {(object.profile_linkedin || object.profile_email) && <div className="contact">
                                <span className="label">{object.label_contact}</span>
                                {object.profile_linkedin && <a className="linkedIn-container" href={object.profile_linkedin}>
                                    <img src="/linkedin.png" alt={object.name} />
                                </a>}
                                {object.profile_email && <a id="cta_contactTeacher" className="email-container" href={"mailto:" + object.profile_email}>
                                    <img src="/email.png" alt={object.name} />
                                </a>}
                            </div>}
                        </div>
                    </div>
                </div>
            ))}
        </Slider>
    </div>;
};

class C85SliderAlumniStudents extends TemplateComponent {

    componentRender(data) {
        return (
            <SliderAlumniStudents data={data} lang={this.props.language} />
        )
    }
}

export default C85SliderAlumniStudents;
